module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/study-37919647ec3de261988243605cb5bfbf.jpg";